export const isEllipsisActive = (id) => {
  const element = document.getElementById(id);
  return element ? element.scrollWidth > element.clientWidth : false;
};

export const scrollCalc = (id) => {
  const element = document.getElementById(id);
  const res = element?.scrollWidth - element?.clientWidth;

  return res > 0 ? res : 0;
};
